import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import outair_equipment from '../entities/outair_equipment'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
interface outair_equipmentState extends ListState<outair_equipment>{
    editoutair_equipment:outair_equipment
    analyseoutair:outair_equipment
}
class UserMutations extends ListMutations<outair_equipment>{

}
class Outair_equipmentModule extends ListModule<outair_equipmentState,any,outair_equipment>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<outair_equipment>(),
        filterlist:new Array<outair_equipment>(),
        loading:false,
        editoutair_equipment:new outair_equipment(),
        analyseoutair:new outair_equipment(),
    }
    actions={
        async getAll(context:ActionContext<outair_equipmentState,any>,payload:any){
            //console.log(payload.data);
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/OutairEquipment/GetPaged',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<outair_equipment>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
            context.state.filterlist=page.items;
        },
        async getPaged(context:ActionContext<outair_equipmentState,any>,payload:any){
          
            context.state.loading=true;
            //debugger
            let reponse=await Ajax.get('/api/services/app/OutairEquipment/GetPaged',{params:payload.data});
            
            context.state.loading=false;
            let page=reponse.data.result as PageResult<outair_equipment>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
            context.state.filterlist=page.items;
        },
        async GetRealPaged(context:ActionContext<outair_equipmentState,any>,payload:any){
            context.state.loading=true;
            //debugger
            let reponse=await Ajax.get('/api/services/app/OutairEquipment/GetRealPaged',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<outair_equipment>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
            return page.items;
        },
        async getfilter(context:ActionContext<outair_equipmentState,any>,payload:any){
            //console.log(payload.data);
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/OutairEquipment/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<outair_equipment>;
            context.state.totalCount=page.totalCount;
            context.state.filterlist=page.items;
        },
        async create(context:ActionContext<outair_equipmentState,any>,payload:any){
            await Ajax.post('/api/services/app/OutairEquipment/Create',payload.data);
        },
        async uploadimg(context:ActionContext<outair_equipmentState,any>,payload:any){
            //console.log(payload.data.UploadData);
            await Ajax.post('/api/services/app/UploadFile/UploadFile',{params:payload.data.UploadData});
        },
        async update(context:ActionContext<outair_equipmentState,any>,payload:any){
            await Ajax.put('/api/services/app/OutairEquipment/Update',payload.data);
        },
        async delete(context:ActionContext<outair_equipmentState,any>,payload:any){
            await Ajax.delete('/api/services/app/OutairEquipment/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<outair_equipmentState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/OutairEquipment/GetById?Id='+payload.id);
            return reponse.data.result as outair_equipment;
        }
    };
    mutations={
        setCurrentPage(state:outair_equipmentState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:outair_equipmentState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:outair_equipmentState,outair_equipment:outair_equipment){   
            state.editoutair_equipment=outair_equipment;
        },
        analyse(state:outair_equipmentState,outair_equipment:outair_equipment){   
            state.analyseoutair=outair_equipment;
        }
    }
}
const outair_equipmentModule=new Outair_equipmentModule();
export default outair_equipmentModule;